<template>
  <div id="progress_model" class="modal" tabindex="-1" role="dialog" aria-labelledby="progress_modelLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal m-3 border-0 shadow-lg" style="background-color: #1a1a1a; border-radius: 20px;">
        <div class="modal-body text-center p-4">
          <div class="mb-3 text-white font-weight-500 font-size-16">{{ text }}</div>
          
          <div class="progress mb-2" style="height: 12px; border-radius: 10px; background-color: #0a0a0a; box-shadow: inset 0 1px 3px rgba(0,0,0,0.5);">
            <div class="progress-bar gradient-a progress-bar-animated progress-bar-striped" 
                 role="progressbar"
                 :aria-valuenow="uploadPercentage" aria-valuemin="0" aria-valuemax="100" 
                 :style="`width:${uploadPercentage}%`">
            </div>
          </div>
          <div class="text-white-50 font-size-12 mb-4">{{ uploadPercentage }}% Complete</div>

          <button type="button" @click="$emit('cancel')"
                  class="btn stella-btn btn-danger rounded-pill font-weight-500 px-4 py-1">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelProgress",
  props: {
    text: {
      type: String,
      default: 'Progress...'
    },
    uploadPercentage: Number
  },
  methods: {
    show() {
      $('#progress_model').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    hide() {
      $('#progress_model').modal('hide');
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
